import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

const ConfirmationModal = ({ title, message, onConfirm, onClose }) => {
  const theme = useTheme();

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
      <div style={{ background: theme.card, borderRadius: 12, width: '90%', maxWidth: 350, border: `1px solid ${theme.border}`, overflow: 'hidden', boxShadow: '0 20px 50px rgba(0,0,0,0.5)' }}>
        <div style={{ padding: 20, textAlign: 'center' }}>
          <div style={{ fontSize: 16, fontWeight: 700, color: theme.text, marginBottom: 10 }}>{title}</div>
          <div style={{ fontSize: 13, color: theme.textM, lineHeight: 1.5 }}>{message}</div>
        </div>
        <div style={{ display: 'flex', borderTop: `1px solid ${theme.border}` }}>
          <button onClick={onClose} style={{ flex: 1, padding: 15, background: 'none', border: 'none', borderRight: `1px solid ${theme.border}`, color: theme.textS, fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>Cancel</button>
          <button onClick={onConfirm} style={{ flex: 1, padding: 15, background: 'none', border: 'none', color: theme.primary, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>Confirm</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
